import { readUnhandledEnumCase } from 'rpc-client-utils';
import Products from 'merchandise-lib/constants/Product';
import { AVAILABLE_CURRENCY_CODES } from 'growth-monetization-service-types';
const ApiNamesSet = new Set(Object.values(Products));
export const hasPurchaseRequest = ctaProps => {
  return ctaProps !== undefined && 'purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined && !('currencyCode' in ctaProps && ctaProps.currencyCode !== undefined);
};
export const hasCurrencyCode = ctaProps => {
  return ctaProps !== undefined && 'currencyCode' in ctaProps && ctaProps.currencyCode !== undefined && !('purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined);
};
export const hasPublicPurchaseRequest = ctaProps => {
  return ctaProps !== undefined && 'purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined && !('currencyCode' in ctaProps && ctaProps.currencyCode !== undefined);
};
export const hasPublicCurrencyCode = ctaProps => {
  return ctaProps !== undefined && 'currencyCode' in ctaProps && ctaProps.currencyCode !== undefined && !('purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined);
};
export const isAvailableCurrencyCode = currencyCode => typeof currencyCode === 'string' && Object.keys(AVAILABLE_CURRENCY_CODES).includes(currencyCode);
export const isApiName = apiName => {
  return apiName !== null && apiName !== undefined && typeof apiName === 'string' && ApiNamesSet.has(apiName);
};
export const isValidTalkToSalesPurchaseMotion = purchaseMotion => ['BLOCKED', 'TALK_TO_SALES', 'TALK_TO_SALES_FALLBACK'].includes(readUnhandledEnumCase(purchaseMotion));
export const isValidProductLine = productLine => ['SALES', 'MARKETING', 'SERVICE', 'CMS', 'COMMERCE', 'OPERATIONS'].includes(productLine);
export const isPublicPurchaseMotion = purchaseMotion => ['BUY_TOUCHLESS', 'TRIAL', 'TALK_TO_SALES', 'TALK_TO_SALES_FALLBACK'].includes(readUnhandledEnumCase(purchaseMotion));
export const isRequestedProductV1 = product => {
  return 'quantity' in product || 'totalQuantity' in product;
};
export const isRequestedQuantityV1 = quantity => {
  return 'totalQuantity' in quantity;
};
export const isPurchaseRequestV1 = request => {
  var _request$products, _request$quantityPack;
  const hasV1Product = (_request$products = request.products) === null || _request$products === void 0 ? void 0 : _request$products.some(product => 'quantity' in product || 'totalQuantity' in product);
  const hasV1QuantityPack = (_request$quantityPack = request.quantityPacks) === null || _request$quantityPack === void 0 ? void 0 : _request$quantityPack.some(pack => 'totalQuantity' in pack);
  return hasV1Product === true || hasV1QuantityPack === true;
};